import Hero from "../Hero/hero";
import About from "../About/about";
import Values from "../Values/values";
import Features from "../Features/features";
import Services from "../Services/services";
import Contact from "../Contact/contact";
import CTA from "../CTA/CTA";
import Portfolio from "../Portfolio/Portfolio";
import Stats from "../Stats/Stats";
import Team from "../Team/team";
import Technologies from "../Technologies/Technologies";
import Testimonials from "../Testimonials/Testimonials";


export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <Values />
      <Features />
      <Stats />
      <Services />
      <Technologies />
      <Portfolio />
      <Testimonials />
      {/* <Team /> */}
      <CTA />
      <Contact />
    </>
  );
}